// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__L5VeI","content":"styles_content__tchua","alertCheckSpan":"styles_alertCheckSpan__saCe7","alertCheckIcons":"styles_alertCheckIcons__10lCQ"};